import type { AnchorHTMLAttributes } from 'react';
import { useDownloads } from './DownloadActivityProvider';
import { isPlainDownloadClick } from './activity';
import type { DownloadIdentity } from './types';
/** Keep native save behavior, including modified clicks. A click acknowledges handoff, never a saved file. */
export function DownloadLink({identity,filename,onClick,...props}:AnchorHTMLAttributes<HTMLAnchorElement>&{identity:DownloadIdentity;filename?:string}){
  const {store}=useDownloads();
  return <a {...props} download={filename??props.download} onClick={event=>{onClick?.(event);if(isPlainDownloadClick(event))store.recordHandoff(identity)}}/>;
}
